(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3584],{

/***/ 92427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ resources; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/lib/useIsFetching.mjs
var useIsFetching = __webpack_require__(38347);
// EXTERNAL MODULE: ../../node_modules/react-use/esm/useDebounce.js
var useDebounce = __webpack_require__(63611);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Navigation2/index.ts + 91 modules
var Navigation2 = __webpack_require__(92609);
// EXTERNAL MODULE: ../../libs/templates/Footer/Footer.tsx + 1 modules
var Footer = __webpack_require__(34810);
// EXTERNAL MODULE: ../../libs/templates/GettingStarted/index.ts + 2 modules
var GettingStarted = __webpack_require__(42576);
// EXTERNAL MODULE: ../../libs/api/routes/resources/queries/index.ts + 7 modules
var queries = __webpack_require__(41472);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(81333);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
;// CONCATENATED MODULE: ../../libs/utils/useAlgoliaFilters/useAlgoliaFilters.ts



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


/**
 * A hook to manage filters for Algolia
 *
 * @returns An object containing the filters string (e.g. `name:"John" AND age:"18" OR age:"19"`) and the updateFilters function
 */

var useAlgoliaFilters = function useAlgoliaFilters() {
  var _useState = (0,react.useState)({}),
      filters = _useState[0],
      setFilters = _useState[1];

  var updateFilters = function updateFilters(index, options) {
    setFilters(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, (0,defineProperty/* default */.Z)({}, index, options));
    });
  };

  var filtersString = Object.entries(filters).map(function (_ref) {
    var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
        name = _ref2[0],
        value = _ref2[1];

    return value.length ? "".concat(name, ":\"").concat(value.map(function (el, index) {
      return "".concat(index > 0 ? " OR ".concat(name, ":\"") : "").concat(el.value, "\"");
    }).join("")) : undefined;
  }).filter(Boolean).join(" AND ");
  return {
    updateFilters: updateFilters,
    filtersString: filtersString
  };
};

/* harmony default export */ var useAlgoliaFilters_useAlgoliaFilters = (useAlgoliaFilters);
;// CONCATENATED MODULE: ../../libs/utils/useAlgoliaFilters/index.ts

// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ./src/views/Resources/components/AdditionalResources/AdditionalResources.tsx
var AdditionalResources = __webpack_require__(29263);
// EXTERNAL MODULE: ./src/views/Resources/components/ResourcesDivider/ResourcesDivider.tsx
var ResourcesDivider = __webpack_require__(33947);
// EXTERNAL MODULE: ../../libs/matcha/components/SearchBar/index.ts + 1 modules
var SearchBar = __webpack_require__(54086);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/Resources/LandingPage/components/Hero/Hero.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var copy = {
  heading: "Resources",
  description: "Books, guides, and videos to help you on your customer data journey"
};

var Hero = function Hero(_ref) {
  var query = _ref.query,
      onQueryChange = _ref.onQueryChange,
      isQueryLoading = _ref.isQueryLoading;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledHeroRecipeBase, {
      variant: "centered",
      copyVariant: "wide",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h1",
            variant: "h1",
            children: copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "h2",
            children: copy.description
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledHeroContents, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchBar/* default */.Z, {
          "aria-label": "Search resources",
          name: "recipes",
          placeholder: "Search resources\u2026",
          value: query,
          onChange: function onChange(_e, value) {
            return onQueryChange(value !== null && value !== void 0 ? value : "");
          },
          onClear: function onClear() {
            return onQueryChange("");
          },
          isLoading: isQueryLoading
        })
      })]
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "e5ngmmk2"
} : 0)("background:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.green[10];
}, ";" + ( true ? "" : 0));

var StyledHeroRecipeBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* default */.ZP,  true ? {
  target: "e5ngmmk1"
} : 0)(recipes_Hero/* Wrapper */.im, "{", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("sm");
}, "{}", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("lg");
}, "{padding-bottom:80px;}}" + ( true ? "" : 0));

var StyledHeroContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* Contents */.AU,  true ? {
  target: "e5ngmmk0"
} : 0)( true ? {
  name: "1tl48zq",
  styles: "max-width:520px"
} : 0);

/* harmony default export */ var Hero_Hero = (Hero);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/matcha/components/Select/useSelect/index.ts + 3 modules
var useSelect = __webpack_require__(27431);
// EXTERNAL MODULE: ../../libs/matcha/components/Select/index.ts + 9 modules
var Select = __webpack_require__(44502);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/components/Input/index.ts + 2 modules
var Input = __webpack_require__(94261);
;// CONCATENATED MODULE: ./src/views/Resources/LandingPage/components/Filters/FilterSelect.tsx



function FilterSelect_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function FilterSelect_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? FilterSelect_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : FilterSelect_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function FilterSelect_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var FilterSelect = function FilterSelect(_ref) {
  var id = _ref.id,
      options = _ref.options,
      onSelect = _ref.onSelect,
      placeholder = _ref.placeholder;

  var _useSelect = (0,useSelect/* default */.Z)({
    options: options,
    id: id,
    onSelect: onSelect,
    config: {
      mobileConfirmationBehaviour: true,
      multiselect: true
    },
    label: placeholder
  }),
      state = _useSelect.state,
      filteredOptions = _useSelect.filteredOptions,
      getControlProps = _useSelect.getControlProps,
      getSelectProps = _useSelect.getSelectProps;

  var selectId = "".concat(id, "-select");
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FilterSelect_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, FilterSelect_objectSpread({
      name: id,
      type: "search",
      resetable: state.filterValue !== "",
      clearIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Select/* ClearSelect */.kr, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ClearIcon */.Rk, {
          size: "small"
        })
      }),
      rightSecondIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ChevronDownIcon */.v4, {})
    }, getControlProps({
      placeholder: placeholder,
      counter: true
    }))), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Select/* default */.ZP, FilterSelect_objectSpread({
      id: selectId,
      name: selectId,
      open: state.open,
      options: options,
      filteredOptions: filteredOptions,
      displayMode: state.displayMode,
      listItemComponent: Select/* MenuItemWithCheckbox */.N1
    }, getSelectProps()))]
  });
};

var FilterSelect_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e18ntyjm0"
} : 0)( true ? {
  name: "js0777",
  styles: "width:100%;z-index:2"
} : 0);

/* harmony default export */ var Filters_FilterSelect = (FilterSelect);
;// CONCATENATED MODULE: ./src/views/Resources/LandingPage/components/Filters/Filters.tsx







var Filters = function Filters(_ref) {
  var _ref$onFilterChange = _ref.onFilterChange,
      onFilterChange = _ref$onFilterChange === void 0 ? function () {
    return null;
  } : _ref$onFilterChange;

  var _useFiltersQuery = (0,queries/* useFiltersQuery */.s_)({
    args: []
  }),
      filters = _useFiltersQuery.data;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionBase, {
    variant: "centered",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledColumnTrack, {
        gap: "small",
        columns: 1,
        overrides: {
          lg: filters === null || filters === void 0 ? void 0 : filters.length
        },
        children: filters === null || filters === void 0 ? void 0 : filters.map(function (_ref2) {
          var id = _ref2.id,
              displayName = _ref2.displayName,
              searchableId = _ref2.searchableId,
              options = _ref2.options;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Filters_FilterSelect, {
            id: id,
            placeholder: displayName,
            options: options,
            onSelect: function onSelect(selectedOptions) {
              return onFilterChange(searchableId, selectedOptions);
            }
          }, id);
        })
      })
    })
  });
};

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ergetrb1"
} : 0)("overflow:visible;", Section/* Wrapper */.im, "{margin:auto;justify-content:unset;padding-top:24px;padding-bottom:32px;row-gap:0;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("lg");
}, "{padding-top:40px;}}" + ( true ? "" : 0));

var StyledColumnTrack = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ColumnTrack/* default */.Z,  true ? {
  target: "ergetrb0"
} : 0)("max-width:520px;row-gap:8px;margin:0 auto;margin-bottom:8px;", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:704px;}", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.up("xl");
}, "{padding:0 80px;}" + ( true ? "" : 0));

/* harmony default export */ var Filters_Filters = (Filters);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(23769);
// EXTERNAL MODULE: ../../libs/matcha/components/Badge/index.ts + 2 modules
var Badge = __webpack_require__(16154);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Card/index.ts + 31 modules
var recipes_Card = __webpack_require__(74881);
;// CONCATENATED MODULE: ./src/views/Resources/LandingPage/components/Card/Card.tsx








var Card = function Card(_ref) {
  var url = _ref.url,
      image = _ref.image,
      label = _ref.label,
      tags = _ref.tags,
      title = _ref.title,
      description = _ref.description,
      cta = _ref.cta;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Card/* default */.ZP, {
    href: url,
    children: [image && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledImage, {
      alt: image.title,
      src: image.src,
      variant: "fill"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Card/* Body */.uT, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Card/* Accessories */.v8, {
        children: [label && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* AccessoriesRow */.OW, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Label */.__, {
            children: label
          })
        }), Boolean(tags === null || tags === void 0 ? void 0 : tags.length) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* AccessoriesRow */.OW, {
          children: tags === null || tags === void 0 ? void 0 : tags.map(function (tag, key) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* default */.Z, {
              variant: "outlined",
              children: tag
            }, key);
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Card/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Headline */.s0, {
          tag: "h3",
          children: title
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Description */.dk, {
          children: description
        })]
      }), cta && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Action */.aU, {
        alignment: "left",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
          iconEnd: Common/* ChevronRightIcon */.XC,
          children: cta
        })
      })]
    })]
  });
};

var StyledImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Card/* Image */.Ee,  true ? {
  target: "e1ad6yv70"
} : 0)("height:170px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{height:209px;}" + ( true ? "" : 0));

/* harmony default export */ var Card_Card = (Card);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
;// CONCATENATED MODULE: ./src/views/Resources/LandingPage/components/CardsGroup/CardsGroup.tsx


var _excluded = ["children"];

function CardsGroup_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CardsGroup_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CardsGroup_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CardsGroup_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var CardsGroup = function CardsGroup(_ref) {
  var children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, CardsGroup_objectSpread(CardsGroup_objectSpread({
    columns: 1,
    overrides: {
      lg: 3
    }
  }, rest), {}, {
    children: children
  }));
};

/* harmony default export */ var CardsGroup_CardsGroup = (CardsGroup);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
;// CONCATENATED MODULE: ./src/views/Resources/LandingPage/components/CardsSection/CardsSection.tsx



var CardsSection_excluded = ["title", "isEmpty", "isLoading", "children"];

function CardsSection_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CardsSection_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CardsSection_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CardsSection_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function CardsSection_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var CardsSection = function CardsSection(_ref2) {
  var title = _ref2.title,
      isEmpty = _ref2.isEmpty,
      _ref2$isLoading = _ref2.isLoading,
      isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading,
      children = _ref2.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref2, CardsSection_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardsSection_StyledSectionBase, CardsSection_objectSpread(CardsSection_objectSpread({
    isEmpty: isEmpty,
    variant: "noCopy"
  }, rest), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Contents */.AU, {
      children: [title && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCopyTextBase, {
        isEmpty: isEmpty,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          variant: "h4",
          children: title
        })
      }), children]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoadingOverlay, {
      "aria-busy": isLoading,
      isLoading: isLoading
    })]
  }));
};

var StyledCopyTextBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* default */.ZP,  true ? {
  target: "e197wcqv2"
} : 0)("margin-bottom:", function (_ref3) {
  var isEmpty = _ref3.isEmpty;
  return isEmpty ? "16px" : "40px";
}, ";" + ( true ? "" : 0));

var CardsSection_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e197wcqv1"
} : 0)("position:relative;", function (_ref4) {
  var isEmpty = _ref4.isEmpty;
  return isEmpty && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(Section/* Wrapper */.im, "{padding-top:40px;padding-bottom:40px;}" + ( true ? "" : 0),  true ? "" : 0);
}, ";" + ( true ? "" : 0));

var _ref =  true ? {
  name: "o9ww1u",
  styles: "opacity:0.5"
} : 0;

var LoadingOverlay = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e197wcqv0"
} : 0)("opacity:0;background-color:", function (_ref5) {
  var theme = _ref5.theme;
  return theme.palette.neutrals.white[100];
}, ";position:absolute;top:0;left:0;bottom:0;right:0;width:100%;transition:opacity ease-in-out 0.3s;z-index:1;pointer-events:none;", function (_ref6) {
  var isLoading = _ref6.isLoading;
  return isLoading && _ref;
}, ";" + ( true ? "" : 0));

/* harmony default export */ var CardsSection_CardsSection = (CardsSection);
;// CONCATENATED MODULE: ./src/views/Resources/LandingPage/components/FeaturedResources/FeaturedResources.tsx



function FeaturedResources_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function FeaturedResources_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? FeaturedResources_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : FeaturedResources_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var FeaturedResources = /*#__PURE__*/(0,react.memo)(function (_ref) {
  var resources = _ref.resources;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardsSection_CardsSection, {
    title: "Featured resources",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardsGroup_CardsGroup, {
      children: resources === null || resources === void 0 ? void 0 : resources.map(function (_ref2, key) {
        var props = (0,esm_extends/* default */.Z)({}, _ref2);

        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card_Card, FeaturedResources_objectSpread({}, props), key);
      })
    })
  });
});
/* harmony default export */ var FeaturedResources_FeaturedResources = (FeaturedResources);
;// CONCATENATED MODULE: ./src/views/Resources/LandingPage/components/ResourcesGrid/useResourcesGrid.ts



var useResourcesGrid = function useResourcesGrid(_ref) {
  var _ref$query = _ref.query,
      query = _ref$query === void 0 ? "" : _ref$query,
      _ref$filters = _ref.filters,
      filters = _ref$filters === void 0 ? "" : _ref$filters;

  var _useResourcesQuery = (0,queries/* useResourcesQuery */.nO)({
    args: [{
      filters: filters,
      query: query
    }],
    options: {
      keepPreviousData: true
    }
  }),
      data = _useResourcesQuery.data,
      hasNextPage = _useResourcesQuery.hasNextPage,
      isLoading = _useResourcesQuery.isLoading,
      fetchNextPage = _useResourcesQuery.fetchNextPage;

  var flattenedPages = (0,react.useMemo)(function () {
    return data === null || data === void 0 ? void 0 : data.pages.flatMap(function (_ref2) {
      var hits = _ref2.hits;
      return hits;
    });
  }, [data === null || data === void 0 ? void 0 : data.pages]);
  return {
    hasNextPage: hasNextPage,
    isLoading: isLoading,
    isEmpty: !isLoading && !hasNextPage && flattenedPages && (flattenedPages === null || flattenedPages === void 0 ? void 0 : flattenedPages.length) === 0,
    fetchNextPage: fetchNextPage,
    flattenedPages: flattenedPages
  };
};

/* harmony default export */ var ResourcesGrid_useResourcesGrid = (useResourcesGrid);
// EXTERNAL MODULE: ../../libs/matcha/components/Loader/index.ts
var Loader = __webpack_require__(37438);
;// CONCATENATED MODULE: ./src/views/Resources/LandingPage/components/ResourcesGrid/ResourcesGrid.tsx




function ResourcesGrid_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ResourcesGrid_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ResourcesGrid_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ResourcesGrid_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function ResourcesGrid_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var ResourcesGrid = function ResourcesGrid(_ref) {
  var resources = _ref.resources,
      isEmpty = _ref.isEmpty,
      isLoading = _ref.isLoading,
      hasNextPage = _ref.hasNextPage,
      title = _ref.title,
      fetchNextPage = _ref.fetchNextPage;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardsSection_CardsSection, {
    isEmpty: isEmpty,
    isLoading: isLoading,
    title: title,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardsGroup_CardsGroup, {
      "data-testid": "loading-overlay",
      "aria-live": "polite",
      "aria-busy": isLoading,
      children: [resources === null || resources === void 0 ? void 0 : resources.map(function (_ref2, key) {
        var props = (0,esm_extends/* default */.Z)({}, _ref2);

        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card_Card, ResourcesGrid_objectSpread({}, props), key);
      }), isEmpty && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          variant: "pMedium",
          children: "Oops! No resources match your criteria."
        })
      })]
    }), isLoading && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoaderWrapper, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Loader/* default */.Z, {})
    }), hasNextPage && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
        onClick: fetchNextPage,
        iconEnd: Common/* ChevronRightIcon */.XC,
        children: "Load more"
      })
    })]
  });
};

var ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1bvu6lg1"
} : 0)("text-align:center;padding:48px 0;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("md");
}, "{padding:80px 0;}" + ( true ? "" : 0));

var LoaderWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1bvu6lg0"
} : 0)( true ? {
  name: "3s82pr",
  styles: "display:grid;align-items:center;justify-content:center;padding:80px 0;margin:0 auto"
} : 0);

/* harmony default export */ var ResourcesGrid_ResourcesGrid = (ResourcesGrid);
// EXTERNAL MODULE: ./src/views/Resources/LandingPage/assets/OgResources.png
var OgResources = __webpack_require__(78025);
var OgResources_default = /*#__PURE__*/__webpack_require__.n(OgResources);
;// CONCATENATED MODULE: ./src/views/Resources/LandingPage/Resources.tsx























var Resources_copy = {
  pageTitle: "Twilio Segment Resources",
  pageDescription: "Segment is a customer data platform (CDP) that helps you collect, clean, and activate your customer data."
};

var getCardsSectionTitle = function getCardsSectionTitle(query, filtersString) {
  if (query === "" && filtersString === "") {
    return "All resources";
  }

  if (query === "") {
    return null;
  }

  return "Search results for \"".concat(query, "\" in resources");
};

var ResourcesView = function ResourcesView() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();

  var _useState = (0,react.useState)(""),
      query = _useState[0],
      setQuery = _useState[1];

  var deferredQuery = (0,react.useDeferredValue)(query);

  var _useState2 = (0,react.useState)(query),
      debouncedQuery = _useState2[0],
      setDebouncedQuery = _useState2[1];

  (0,useDebounce/* default */.Z)(function () {
    return setDebouncedQuery(query);
  }, 200, [query]);
  var ongoingFetches = (0,useIsFetching/* useIsFetching */.y)({
    queryKey: ["resources"]
  });
  var isQueryLoading = ongoingFetches > 0;

  var _useAlgoliaFilters = useAlgoliaFilters_useAlgoliaFilters(),
      updateFilters = _useAlgoliaFilters.updateFilters,
      filtersString = _useAlgoliaFilters.filtersString;

  var _useFeaturedResources = (0,queries/* useFeaturedResourcesQuery */.Nv)({
    args: [{
      max: 3
    }]
  }),
      featuredResources = _useFeaturedResources.data;

  var _useResourcesGrid = ResourcesGrid_useResourcesGrid({
    query: debouncedQuery,
    filters: filtersString
  }),
      flattenedPages = _useResourcesGrid.flattenedPages,
      isEmpty = _useResourcesGrid.isEmpty,
      hasNextPage = _useResourcesGrid.hasNextPage,
      fetchNextPage = _useResourcesGrid.fetchNextPage;

  var showFeaturedResources = deferredQuery === "" && filtersString === "" && featuredResources;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: Resources_copy.pageTitle,
      pageDescription: Resources_copy.pageDescription,
      pageOG: (OgResources_default()),
      bodyBackground: theme.palette.neutrals.white[100],
      themeColor: theme.palette.neutrals.white[100],
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation2/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {
        query: query,
        onQueryChange: setQuery,
        isQueryLoading: isQueryLoading
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Filters_Filters, {
          onFilterChange: updateFilters
        }), showFeaturedResources && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeaturedResources_FeaturedResources, {
            resources: featuredResources
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ResourcesDivider/* default */.Z, {})]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ResourcesGrid_ResourcesGrid, {
          title: getCardsSectionTitle(deferredQuery, filtersString),
          resources: flattenedPages,
          isEmpty: isEmpty,
          isLoading: isQueryLoading,
          hasNextPage: hasNextPage,
          fetchNextPage: fetchNextPage
        }), isEmpty && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ResourcesDivider/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeaturedResources_FeaturedResources, {
            resources: featuredResources
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ResourcesDivider/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdditionalResources/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted["default"], {})]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
    })
  });
};

/* harmony default export */ var LandingPage_Resources = (ResourcesView);

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e17hwoyh0"
} : 0)( true ? "" : 0);
// EXTERNAL MODULE: ../../libs/api/algolia/client.ts
var client = __webpack_require__(2017);
// EXTERNAL MODULE: ../../libs/api/routes/resources/contexts/algoliaClientContext.ts
var algoliaClientContext = __webpack_require__(82682);
// EXTERNAL MODULE: ../../libs/contexts/staticSiteBackend.ts
var contexts_staticSiteBackend = __webpack_require__(86708);
;// CONCATENATED MODULE: ./src/pages/resources/index.tsx







var Resources = function Resources() {
  var staticSiteBackend = (0,react.useMemo)(function () {
    return (0,contexts_staticSiteBackend/* createStaticSiteBackend */.I4)();
  }, []);
  var algoliaClient = (0,react.useMemo)(function () {
    return (0,client/* createClient */.e)();
  }, []);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(contexts_staticSiteBackend/* StaticSiteBackendProvider */.D1, {
    value: staticSiteBackend,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(algoliaClientContext/* AlgoliaClientProvider */.vS, {
      value: algoliaClient,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LandingPage_Resources, {})
    })
  });
};

var __N_SSG = true;
/* harmony default export */ var resources = (Resources);

/***/ }),

/***/ 29263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _segment_matcha_components_ColumnTrack__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85735);
/* harmony import */ var _segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74870);
/* harmony import */ var _segment_matcha_components_Icons_Common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6580);
/* harmony import */ var _segment_matcha_recipes_Card__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74881);
/* harmony import */ var _segment_matcha_recipes_CopyText__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94136);
/* harmony import */ var _segment_matcha_recipes_Section__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88392);
/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(43848);
/* harmony import */ var _segment_contexts_page__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17782);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52903);












var copy = {
  heading: "Additional Resources"
};
var data = [{
  slug: "growth-center/",
  title: "Growth Center",
  description: "Learn how to implement and scale high-performing growth strategies.",
  cta: "Visit our Growth Center"
}, {
  slug: "blog/",
  title: "Our Blog",
  description: "Stay up-to-date with our latest articles on all things data.",
  cta: "Read our blog"
}, {
  slug: "good-data-better-marketing/",
  title: "Good Data, Better Marketing",
  description: "Tune in to hear from enterprise experts as they share how to use data as a competitive asset to drive customer engagement.",
  cta: "Listen to our podcast"
}];
var AdditionalResources = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function () {
  var pageConfig = (0,_segment_contexts_page__WEBPACK_IMPORTED_MODULE_8__/* .usePageConfig */ .Gm)();
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(StyledSection, {
    variant: "centered",
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_segment_matcha_recipes_Section__WEBPACK_IMPORTED_MODULE_7__/* .Copy */ .CK, {
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_segment_matcha_recipes_CopyText__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
        centered: true,
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_segment_matcha_recipes_CopyText__WEBPACK_IMPORTED_MODULE_6__/* .Heading */ .X6, {
          tag: "h2",
          variant: "h2",
          children: copy.heading
        })
      })
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_segment_matcha_recipes_Section__WEBPACK_IMPORTED_MODULE_7__/* .Contents */ .AU, {
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_segment_matcha_components_ColumnTrack__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        columns: 1,
        overrides: {
          lg: 3
        },
        children: data.map(function (_ref) {
          var slug = _ref.slug,
              title = _ref.title,
              description = _ref.description,
              cta = _ref.cta;
          return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_segment_matcha_recipes_Card__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
            href: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("/".concat(slug), pageConfig),
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_segment_matcha_recipes_Card__WEBPACK_IMPORTED_MODULE_5__/* .Body */ .uT, {
              children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_segment_matcha_recipes_Card__WEBPACK_IMPORTED_MODULE_5__/* .Copy */ .CK, {
                children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_segment_matcha_recipes_Card__WEBPACK_IMPORTED_MODULE_5__/* .Headline */ .s0, {
                  tag: "h3",
                  children: title
                }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_segment_matcha_recipes_Card__WEBPACK_IMPORTED_MODULE_5__/* .Description */ .dk, {
                  children: description
                })]
              }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_segment_matcha_recipes_Card__WEBPACK_IMPORTED_MODULE_5__/* .Action */ .aU, {
                alignment: "left",
                children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                  iconEnd: _segment_matcha_components_Icons_Common__WEBPACK_IMPORTED_MODULE_4__/* .ChevronRightIcon */ .XC,
                  children: cta
                })
              })]
            })
          }, slug);
        })
      })
    })]
  });
});

var StyledSection = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_segment_matcha_recipes_Section__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP,  true ? {
  target: "eskhgws0"
} : 0)("padding-bottom:40px;", _segment_matcha_recipes_Section__WEBPACK_IMPORTED_MODULE_7__/* .Wrapper */ .im, "{row-gap:50px;}", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("lg");
}, "{padding-bottom:80px;}" + ( true ? "" : 0));

/* harmony default export */ __webpack_exports__["Z"] = (AdditionalResources);

/***/ }),

/***/ 33947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var _segment_matcha_components_Divider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76305);
/* harmony import */ var _segment_matcha_recipes_Section__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88392);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52903);





var ResourcesDivider = function ResourcesDivider() {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(StyledSectionBase, {
    variant: "noCopy",
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_segment_matcha_recipes_Section__WEBPACK_IMPORTED_MODULE_2__/* .Contents */ .AU, {
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_segment_matcha_components_Divider__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})
    })
  });
};

var StyledSectionBase = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_segment_matcha_recipes_Section__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP,  true ? {
  target: "e5492tw0"
} : 0)(_segment_matcha_recipes_Section__WEBPACK_IMPORTED_MODULE_2__/* .Wrapper */ .im, "{padding-top:0;padding-bottom:0;}" + ( true ? "" : 0));

/* harmony default export */ __webpack_exports__["Z"] = (ResourcesDivider);

/***/ }),

/***/ 2017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ createClient; }
/* harmony export */ });
/* harmony import */ var algoliasearch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61970);
/* harmony import */ var algoliasearch__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(algoliasearch__WEBPACK_IMPORTED_MODULE_0__);


var createClient = function createClient() {
  var _process$env$NEXT_PUB, _process$env$NEXT_PUB2;

  return algoliasearch__WEBPACK_IMPORTED_MODULE_0___default()((_process$env$NEXT_PUB = "16K0JFOELG") !== null && _process$env$NEXT_PUB !== void 0 ? _process$env$NEXT_PUB : "", (_process$env$NEXT_PUB2 = "d8d6f81bd62f98b1e42cce94c827afd2") !== null && _process$env$NEXT_PUB2 !== void 0 ? _process$env$NEXT_PUB2 : "");
};



/***/ }),

/***/ 82682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p8": function() { return /* binding */ useResourcesIndex; },
/* harmony export */   "vS": function() { return /* binding */ AlgoliaClientProvider; }
/* harmony export */ });
/* unused harmony exports algoliaClientContext, useAlgoliaClient, createResourcesIndex */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var algoliaClientContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
var AlgoliaClientProvider = algoliaClientContext.Provider;
var useAlgoliaClient = function useAlgoliaClient() {
  var AlgoliaClient = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(algoliaClientContext);

  if (!AlgoliaClient) {
    throw new Error("Resources index isn't available. Please set it via AlgoliaClientProvider component.");
  }

  return AlgoliaClient;
};
var useResourcesIndex = function useResourcesIndex() {
  var client = useAlgoliaClient();
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return createResourcesIndex(client);
  }, [client]);
};
var createResourcesIndex = function createResourcesIndex(client) {
  var _process$env$NEXT_PUB;

  var internalClient = client;
  return internalClient.initIndex((_process$env$NEXT_PUB = "Resources") !== null && _process$env$NEXT_PUB !== void 0 ? _process$env$NEXT_PUB : "");
};

/***/ }),

/***/ 41472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Nv": function() { return /* reexport */ useFeaturedResourcesQuery; },
  "s_": function() { return /* reexport */ useFiltersQuery; },
  "nO": function() { return /* reexport */ useResourcesQuery; },
  "oB": function() { return /* reexport */ useSingleResourceQuery; }
});

// UNUSED EXPORTS: createAllResourcesQuery, createFeaturedResourcesQuery, createFiltersQuery, createResourcesQuery, createSingleResourceQuery, useAllResourcesQuery

// EXTERNAL MODULE: ../../libs/utils/createQueryHook/createQueryHook.ts
var createQueryHook = __webpack_require__(74048);
// EXTERNAL MODULE: ../../libs/contexts/staticSiteBackend.ts
var staticSiteBackend = __webpack_require__(86708);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(12741);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(829);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
;// CONCATENATED MODULE: ../../libs/api/staticSiteBackend/resources.ts






function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var fetchAllResources = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(client, options) {
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", client.get("/content/entries/resource", options).then(function (res) {
              var transformedResponse = res.map(function (resource) {
                var _resource$image, _resource$image2, _resource$image3, _resource$image3$fiel, _resource$image4, _resource$image4$fiel, _resource$resourceSin, _resource$resourceSin2, _resource$resourceSin3, _resource$resourceSin4, _resource$resourceSin5, _resource$resourceSin6, _resource$resourceSin7, _resource$resourceSin8, _resource$resourceSin9, _resource$resourceSin10, _resource$resourceSin11, _resource$resourceSin12, _resource$resourceSin13, _resource$resourceSin14, _resource$resourceSin15, _resource$resourceSin16, _resource$resourceSin17, _resource$resourceSin18, _resource$resourceSin19, _resource$resourceSin20, _resource$resourceSin21;

                return _objectSpread(_objectSpread({}, resource), {}, {
                  image: {
                    src: (_resource$image = resource.image) === null || _resource$image === void 0 ? void 0 : _resource$image.fields.file.url,
                    title: (_resource$image2 = resource.image) === null || _resource$image2 === void 0 ? void 0 : _resource$image2.fields.title,
                    width: (_resource$image3 = resource.image) === null || _resource$image3 === void 0 ? void 0 : (_resource$image3$fiel = _resource$image3.fields.file.details.image) === null || _resource$image3$fiel === void 0 ? void 0 : _resource$image3$fiel.width,
                    height: (_resource$image4 = resource.image) === null || _resource$image4 === void 0 ? void 0 : (_resource$image4$fiel = _resource$image4.fields.file.details.image) === null || _resource$image4$fiel === void 0 ? void 0 : _resource$image4$fiel.height
                  },
                  resourceSingle: _objectSpread(_objectSpread({}, (_resource$resourceSin = resource.resourceSingle) === null || _resource$resourceSin === void 0 ? void 0 : _resource$resourceSin.fields), {}, {
                    socialImage: {
                      src: (_resource$resourceSin2 = resource.resourceSingle) === null || _resource$resourceSin2 === void 0 ? void 0 : _resource$resourceSin2.fields.socialImage.fields.file.url,
                      title: (_resource$resourceSin3 = resource.resourceSingle) === null || _resource$resourceSin3 === void 0 ? void 0 : _resource$resourceSin3.fields.socialImage.fields.title,
                      width: (_resource$resourceSin4 = resource.resourceSingle) === null || _resource$resourceSin4 === void 0 ? void 0 : (_resource$resourceSin5 = _resource$resourceSin4.fields.socialImage.fields.file.details.image) === null || _resource$resourceSin5 === void 0 ? void 0 : _resource$resourceSin5.width,
                      height: (_resource$resourceSin6 = resource.resourceSingle) === null || _resource$resourceSin6 === void 0 ? void 0 : (_resource$resourceSin7 = _resource$resourceSin6.fields.socialImage.fields.file.details.image) === null || _resource$resourceSin7 === void 0 ? void 0 : _resource$resourceSin7.height
                    },
                    resourcePromo: _objectSpread(_objectSpread({}, (_resource$resourceSin8 = resource.resourceSingle) === null || _resource$resourceSin8 === void 0 ? void 0 : (_resource$resourceSin9 = _resource$resourceSin8.fields.resourcePromo) === null || _resource$resourceSin9 === void 0 ? void 0 : _resource$resourceSin9.fields), {}, {
                      image: {
                        src: (_resource$resourceSin10 = resource.resourceSingle) === null || _resource$resourceSin10 === void 0 ? void 0 : (_resource$resourceSin11 = _resource$resourceSin10.fields.resourcePromo) === null || _resource$resourceSin11 === void 0 ? void 0 : _resource$resourceSin11.fields.image.fields.file.url,
                        title: (_resource$resourceSin12 = resource.resourceSingle) === null || _resource$resourceSin12 === void 0 ? void 0 : (_resource$resourceSin13 = _resource$resourceSin12.fields.resourcePromo) === null || _resource$resourceSin13 === void 0 ? void 0 : _resource$resourceSin13.fields.image.fields.title,
                        width: (_resource$resourceSin14 = resource.resourceSingle) === null || _resource$resourceSin14 === void 0 ? void 0 : (_resource$resourceSin15 = _resource$resourceSin14.fields.resourcePromo) === null || _resource$resourceSin15 === void 0 ? void 0 : (_resource$resourceSin16 = _resource$resourceSin15.fields.image.fields.file.details.image) === null || _resource$resourceSin16 === void 0 ? void 0 : _resource$resourceSin16.width,
                        height: (_resource$resourceSin17 = resource.resourceSingle) === null || _resource$resourceSin17 === void 0 ? void 0 : (_resource$resourceSin18 = _resource$resourceSin17.fields.resourcePromo) === null || _resource$resourceSin18 === void 0 ? void 0 : (_resource$resourceSin19 = _resource$resourceSin18.fields.image.fields.file.details.image) === null || _resource$resourceSin19 === void 0 ? void 0 : _resource$resourceSin19.height
                      }
                    }),
                    faqs: (_resource$resourceSin20 = resource.resourceSingle) === null || _resource$resourceSin20 === void 0 ? void 0 : (_resource$resourceSin21 = _resource$resourceSin20.fields.faqs) === null || _resource$resourceSin21 === void 0 ? void 0 : _resource$resourceSin21.map(function (_ref2) {
                      var fields = _ref2.fields;
                      return fields;
                    })
                  })
                });
              });
              return sortBy_default()(transformedResponse, ["title"]);
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchAllResources(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var fetchFeaturedResources = /*#__PURE__*/function () {
  var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(_ref3) {
    var client, _ref3$max, max, options, data;

    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            client = _ref3.client, _ref3$max = _ref3.max, max = _ref3$max === void 0 ? 3 : _ref3$max, options = _ref3.options;
            _context2.next = 3;
            return fetchAllResources(client, options);

          case 3:
            data = _context2.sent.filter(function (item) {
              return item.featured;
            }).slice(0, max);
            return _context2.abrupt("return", data);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchFeaturedResources(_x3) {
    return _ref4.apply(this, arguments);
  };
}();
var fetchResource = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5) {
    var client, options, url, data;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            client = _ref5.client, options = _ref5.options, url = _ref5.url;
            _context3.next = 3;
            return fetchAllResources(client, options);

          case 3:
            data = _context3.sent.find(function (item) {
              return item.url === url;
            });
            return _context3.abrupt("return", data);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function fetchResource(_x4) {
    return _ref6.apply(this, arguments);
  };
}()));
var fetchSingleResource = /*#__PURE__*/function () {
  var _ref8 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(_ref7) {
    var client, options, url, data;
    return regenerator_default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            client = _ref7.client, options = _ref7.options, url = _ref7.url;
            _context4.next = 3;
            return fetchAllResources(client, options);

          case 3:
            data = _context4.sent.find(function (item) {
              var _item$resourceSingle;

              return ((_item$resourceSingle = item.resourceSingle) === null || _item$resourceSingle === void 0 ? void 0 : _item$resourceSingle.url) === url;
            });
            return _context4.abrupt("return", data === null || data === void 0 ? void 0 : data.resourceSingle);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function fetchSingleResource(_x5) {
    return _ref8.apply(this, arguments);
  };
}();
var fetchFilters = /*#__PURE__*/function () {
  var _ref10 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(_ref9) {
    var client, filtersObjs, options, allResources, filters;
    return regenerator_default().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            client = _ref9.client, filtersObjs = _ref9.filtersObjs, options = _ref9.options;
            _context5.next = 3;
            return fetchAllResources(client, options);

          case 3:
            allResources = _context5.sent;
            filters = filtersObjs.map(function (_ref11) {
              var id = _ref11.id,
                  displayName = _ref11.displayName,
                  searchableId = _ref11.searchableId;
              var options = allResources.reduce(function (acc, resource) {
                if (resource[id]) {
                  var value = resource[id];
                  if (typeof value === "string") acc.push(value);else if (Array.isArray(value)) acc.push.apply(acc, (0,toConsumableArray/* default */.Z)(value));else {
                    throw new Error("Unexpected value type for filter ".concat(id));
                  }
                }

                return acc;
              }, []);
              return {
                id: id,
                searchableId: searchableId,
                displayName: displayName,
                options: sortBy_default()(Array.from(new Set(options)).map(function (option) {
                  return {
                    value: option,
                    text: option
                  };
                }), function (opt) {
                  return opt.value.toLowerCase();
                })
              };
            });
            return _context5.abrupt("return", filters);

          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function fetchFilters(_x6) {
    return _ref10.apply(this, arguments);
  };
}();
;// CONCATENATED MODULE: ../../libs/api/routes/resources/queries/allResourcesQuery.tsx



var createAllResourcesQuery = function createAllResourcesQuery(client) {
  return [["resources", "allResourcesQuery"], function () {
    return fetchAllResources(client);
  }];
};
var useAllResourcesQuery = (0,createQueryHook/* default */.Z)(createAllResourcesQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
;// CONCATENATED MODULE: ../../libs/api/routes/resources/queries/featuredResourcesQuery.ts



var createFeaturedResourcesQuery = function createFeaturedResourcesQuery(client, _ref) {
  var max = _ref.max;
  return [["resources", "featuredResourcesQuery", max], function (_ref2) {
    var signal = _ref2.signal;
    return fetchFeaturedResources({
      client: client,
      max: max,
      options: {
        signal: signal
      }
    });
  }];
};
var useFeaturedResourcesQuery = (0,createQueryHook/* default */.Z)(createFeaturedResourcesQuery, staticSiteBackend/* useStaticSiteBackend */.gR);
;// CONCATENATED MODULE: ../../libs/api/routes/resources/queries/filtersQuery.ts



var defaultFilters = [{
  id: "label",
  searchableId: "label",
  displayName: "Type of content"
}, {
  id: "tags",
  searchableId: "tags",
  displayName: "Topic"
}];
var createFiltersQuery = function createFiltersQuery(client) {
  var filtersObjs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultFilters;
  return [["resources", "filters"], function (_ref) {
    var signal = _ref.signal;
    return fetchFilters({
      client: client,
      filtersObjs: filtersObjs,
      options: {
        signal: signal
      }
    });
  }];
};
var useFiltersQuery = (0,createQueryHook/* default */.Z)(createFiltersQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
// EXTERNAL MODULE: ../../libs/utils/createInfinityQueryHook/createInfinityQueryHook.ts
var createInfinityQueryHook = __webpack_require__(99338);
// EXTERNAL MODULE: ../../libs/utils/fsCache/index.ts
var fsCache = __webpack_require__(96904);
;// CONCATENATED MODULE: ../../libs/api/algolia/resources.ts
/* provided dependency */ var process = __webpack_require__(34406);





function resources_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function resources_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? resources_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : resources_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


var attributesToFetch = ["title", "url", "image", "label", "tags", "description", "cta", "featured"];
var fetchResources = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {
    var query, searchIndex, _ref$page, page, _ref$distinct, distinct, hitsPerPage, filters, cacheKey, enabled, algoliaCachedSearch;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            query = _ref.query, searchIndex = _ref.searchIndex, _ref$page = _ref.page, page = _ref$page === void 0 ? 0 : _ref$page, _ref$distinct = _ref.distinct, distinct = _ref$distinct === void 0 ? 0 : _ref$distinct, hitsPerPage = _ref.hitsPerPage, filters = _ref.filters, cacheKey = _ref.cacheKey;
            enabled = Boolean(process.env.ENABLE_FS_CACHE);
            _context.next = 4;
            return (0,fsCache/* createFsCacheProxy */.c)(["resources-fetchResources"].concat((0,toConsumableArray/* default */.Z)(cacheKey ? cacheKey : [query, page !== null && page !== void 0 ? page : null, distinct !== null && distinct !== void 0 ? distinct : null, hitsPerPage !== null && hitsPerPage !== void 0 ? hitsPerPage : null, filters !== null && filters !== void 0 ? filters : null])), function () {
              return searchIndex.search.apply(searchIndex, arguments).then(function (res) {
                return resources_objectSpread(resources_objectSpread({}, res), {}, {
                  hits: res.hits.map(function (hit) {
                    var _hit$image, _hit$image2;

                    return resources_objectSpread(resources_objectSpread({}, hit), {}, {
                      image: {
                        src: (_hit$image = hit.image) === null || _hit$image === void 0 ? void 0 : _hit$image.src,
                        title: (_hit$image2 = hit.image) === null || _hit$image2 === void 0 ? void 0 : _hit$image2.alt
                      }
                    });
                  })
                });
              });
            }, {
              enabled: enabled
            });

          case 4:
            algoliaCachedSearch = _context.sent;
            return _context.abrupt("return", algoliaCachedSearch(query, {
              attributesToRetrieve: ["-*"].concat(attributesToFetch),
              distinct: distinct,
              page: page,
              hitsPerPage: hitsPerPage,
              filters: filters
            }));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchResources(_x) {
    return _ref2.apply(this, arguments);
  };
}();
// EXTERNAL MODULE: ../../libs/api/routes/resources/contexts/algoliaClientContext.ts
var algoliaClientContext = __webpack_require__(82682);
;// CONCATENATED MODULE: ../../libs/api/routes/resources/queries/resourcesQuery.ts





var createResourcesQuery = function createResourcesQuery(searchIndex, _ref) {
  var query = _ref.query,
      hitsPerPage = _ref.hitsPerPage,
      filters = _ref.filters;
  return [["resources", "resourcesQuery", query, hitsPerPage, filters], /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref2) {
      var pageParam;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              pageParam = _ref2.pageParam;
              return _context.abrupt("return", fetchResources({
                searchIndex: searchIndex,
                page: pageParam,
                query: query,
                filters: filters,
                hitsPerPage: 6
              }));

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }()];
};
var useResourcesQuery = (0,createInfinityQueryHook/* default */.Z)(createResourcesQuery, algoliaClientContext/* useResourcesIndex */.p8, {
  staleTime: Infinity,
  getPreviousPageParam: function getPreviousPageParam(_ref4) {
    var _ref4$page = _ref4.page,
        page = _ref4$page === void 0 ? 0 : _ref4$page;
    var prevPage = page - 1;

    if (prevPage < 0) {
      return;
    }

    return prevPage;
  },
  getNextPageParam: function getNextPageParam(_ref5) {
    var _ref5$page = _ref5.page,
        page = _ref5$page === void 0 ? 0 : _ref5$page,
        nbPages = _ref5.nbPages;
    var nextPage = page + 1;

    if (nextPage >= nbPages) {
      return;
    }

    return nextPage;
  }
});
;// CONCATENATED MODULE: ../../libs/api/routes/resources/queries/singleResourceQuery.tsx



var createSingleResourceQuery = function createSingleResourceQuery(client, slug) {
  return [["resources/singleResourceQuery", slug], function () {
    return fetchSingleResource({
      client: client,
      url: "/resources/".concat(slug, "/")
    });
  }];
};
var useSingleResourceQuery = (0,createQueryHook/* default */.Z)(createSingleResourceQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
;// CONCATENATED MODULE: ../../libs/api/routes/resources/queries/index.ts






/***/ }),

/***/ 34810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/index.ts + 4 modules
var recipes_Footer = __webpack_require__(80653);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Footer/data.ts
var Footer_data = __webpack_require__(52661);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var BrandLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ed41syo0"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.tsx


var _excluded = ["appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












var Footer = function Footer(_ref) {
  var appearance = _ref.appearance,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var footerAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var ctaText = "See how it works";
  var data = (0,Footer_data/* default */.Z)(pageConfig);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Footer/* default */.Z, _objectSpread({
    bottomLinks: data.bottomLinks,
    mainLinks: data.mainLinks,
    copyright: data.copyright,
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: footerAppearance,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/", pageConfig),
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandLink, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
            alt: "Twilio, Inc.",
            footer: true
          })
        })
      })
    }),
    cta: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      color: "primary",
      variant: "filled",
      size: "large",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
      children: ctaText
    }),
    appearance: appearance
  }, props));
};

/* harmony default export */ var Footer_Footer = (Footer);

/***/ }),

/***/ 52661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43848);


var getData = function getData(pageConfig) {
  return {
    logo: {
      src: "/images/SegmentLogoWhite.png",
      srcSet: "/images/SegmentLogoWhite@2x.png 2x",
      alt: "Twilio, Inc.",
      width: 300,
      height: 65
    },
    bottomLinks: [{
      url: "https://www.twilio.com/legal/privacy/",
      title: "Privacy policy"
    }, {
      url: "https://www.twilio.com/legal/tos/",
      title: "Terms of Service"
    }],
    mainLinks: [{
      title: "Products",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/connections/", pageConfig),
        title: "Connections"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/protocols/", pageConfig),
        title: "Protocols"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/unify/", pageConfig),
        title: "Unify"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/twilio-engage/", pageConfig),
        title: "Twilio Engage"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/customer-data-platform/", pageConfig),
        title: "Customer Data Platform",
        rel: "nofollow"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/catalog/", pageConfig),
        title: "Integrations Catalog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/pricing/", pageConfig),
        title: "Pricing"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/security/", pageConfig),
        title: "Security"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/gdpr/", pageConfig),
        title: "GDPR"
      }]
    }, {
      title: "For Developers",
      links: [{
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://docs.segmentapis.com/",
        title: "Segment API"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/developer-portal/", pageConfig),
        title: "Build on Segment"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/opensource/", pageConfig),
        title: "Open Source"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/engineering/", pageConfig),
        title: "Engineering Team"
      }]
    }, {
      title: "Company",
      links: [{
        url: "https://www.twilio.com/company/jobs/",
        title: "Careers"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/blog/", pageConfig),
        title: "Blog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/newsroom/", pageConfig),
        title: "Press"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/events/", pageConfig),
        title: "Events"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/good-data-better-marketing/", pageConfig),
        title: "Podcast"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/growth-center/", pageConfig),
        title: "Growth Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/data-hub/", pageConfig),
        title: "Data Hub"
      }]
    }, {
      title: "Support",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/help/", pageConfig),
        title: "Help Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/contact/", pageConfig),
        title: "Contact us"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/", pageConfig),
        title: "Resources"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/recipes/", pageConfig),
        title: "Recipes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/services/", pageConfig),
        title: "Professional Services"
      }, {
        url: "https://segment.com/security/bulletins/",
        title: "Security Bulletins"
      }, {
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://segment.com/release-notes/",
        title: "Release Notes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/", pageConfig),
        title: "Become a Partner"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/cdp/", pageConfig),
        title: "Guide to Customer Data Platforms"
      }]
    }],
    copyright: "\xA9 ".concat(new Date().getUTCFullYear(), " Twilio Inc. All Rights Reserved.")
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (getData);

/***/ }),

/***/ 85807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useInView; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useInView/useInView.ts

/**
 * A hook to observe elements in the viewport
 * @param ref - A ref to the element to observe
 * @param options - The options for the IntersectionObserver
 * @returns A boolean indicating if the element is in the viewport
 */

var useIsInView = function useIsInView(ref) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$stopOnIntersecti = _ref.stopOnIntersection,
      stopOnIntersection = _ref$stopOnIntersecti === void 0 ? true : _ref$stopOnIntersecti,
      options = _ref.options;

  var _useState = (0,react.useState)(false),
      isInView = _useState[0],
      setIsInView = _useState[1];

  var inViewRef = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    var intersectionObserver = new IntersectionObserver(function (intersection) {
      if (intersection.some(function (i) {
        return i.isIntersecting;
      })) {
        inViewRef.current = true;
        setIsInView(true);

        if (stopOnIntersection) {
          intersectionObserver.disconnect();
        }
      } else if (inViewRef.current) {
        inViewRef.current = false;
        setIsInView(false);
      }
    }, options);

    if (ref.current) {
      intersectionObserver.observe(ref.current);
    }

    return function () {
      intersectionObserver.disconnect();
    };
  }, [ref]);
  return isInView;
};

/* harmony default export */ var useInView = (useIsInView);
;// CONCATENATED MODULE: ../../libs/utils/useInView/index.ts


/***/ }),

/***/ 8521:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources",
      function () {
        return __webpack_require__(92427);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 63611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useDebounce; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _useTimeoutFn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45641);


function useDebounce(fn, ms, deps) {
    if (ms === void 0) { ms = 0; }
    if (deps === void 0) { deps = []; }
    var _a = (0,_useTimeoutFn__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(fn, ms), isReady = _a[0], cancel = _a[1], reset = _a[2];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(reset, deps);
    return [isReady, cancel];
}


/***/ }),

/***/ 45641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useTimeoutFn; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

function useTimeoutFn(fn, ms) {
    if (ms === void 0) { ms = 0; }
    var ready = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    var timeout = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var callback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(fn);
    var isReady = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () { return ready.current; }, []);
    var set = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
        ready.current = false;
        timeout.current && clearTimeout(timeout.current);
        timeout.current = setTimeout(function () {
            ready.current = true;
            callback.current();
        }, ms);
    }, [ms]);
    var clear = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
        ready.current = null;
        timeout.current && clearTimeout(timeout.current);
    }, []);
    // update ref when function changes
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        callback.current = fn;
    }, [fn]);
    // set on mount, clear on unmount
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        set();
        return clear;
    }, [ms]);
    return [isReady, clear, set];
}


/***/ }),

/***/ 78025:
/***/ (function(module) {

module.exports = "/_next/static/images/OgResources-c0a58f05a8c20db7722fc7fb90d6f5b4.png";

/***/ }),

/***/ 23769:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,9137,8943,1970,6861,6234,4136,2073,6784,8392,5735,2429,2609,948,8187,442,4881,9550,6818,2389,9774,2888,179], function() { return __webpack_exec__(8521); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);